import { Component } from 'react';

import { window } from '../../globals';
import { nuc } from '../../utils';
import Link from '../generic/Link/Link';
import SupportLink from '../generic/Link/SupportLink';
import type { UpdateHookType } from '../../../shared/model-typings';
import type { RouterProps } from '../../types';

type Params = {
  service: UpdateHookType;
};

type Query = {
  error?: Error;
};

type Props = RouterProps<Params, Query>;

export default class EnsureWebhook extends Component<Props, any> {
  componentDidMount() {
    if (!this.props.location.query.error) {
      this.timer = setTimeout(() => {
        window.close();
      }, 10000);
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  timer: number;

  renderError = () => (
    <div className="container margin-top">
      <div className="card card-error text-center">
        <h2>Project Webhooks Could Not Be Updated</h2>
        <p>
          Typically this is due to lack of permissions on the requested repository. Try disconnecting and
          reauthenticating with {this.props.params.service === 'bitbucket_cloud' ? 'bitbucket' : this.props.params.service}
          {' '}
          <Link
            to={`/projects/${nuc(this.props.location.query.locator)}/settings/builds`}
            openInNewTab
          >
            here
          </Link>. If that does not work, please
          {' '}
          <SupportLink>
            reach out
          </SupportLink>.
        </p>
      </div>
    </div>
  );

  renderSuccess = () => (
    <div className="container margin-top">
      <div className="card card-primary text-center">
        <h2>Project Webhooks Updated Successfully</h2>
        <p>This page should automatically close in 10 seconds...</p>
      </div>
    </div>
  );

  render() {
    if (this.props.location.query.error) {
      return this.renderError();
    }

    return this.renderSuccess();
  }
}
